import {
    Component, OnInit, EventEmitter,
    ViewChild, ElementRef, ChangeDetectorRef
} from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'app/services/data.service';
import { ProjectManagementService } from 'app/services/project-management.service';
import { FrontEndService } from 'app/services/front-end.service';
import { LogService } from 'app/services/log.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from '@uirouter/angular';
import * as moment from 'moment';
import { MultipleDatePickerComponent } from "../multiple-date-picker-angular/dist";

@Component({
    selector: 'app-create-project',
    templateUrl: './create-project.component.html',
    styleUrls: ['./create-project.component.scss']
})
export class CreateProjectComponent implements OnInit {

    title = "";
    useful_information = "";
    required_delivery_date = "";
    // interim_date = "";
    interim_date_string = "";
    interim_date = [];
    technical_field = "";
    claim_search = "";
    prior_art = "";
    project_status = "";
    empty_value = "";
    patent_engineer = [];
    technical_expert = [];
    legal_counsel = [];
    prior_art_cut_off_date = [];
    prior_art_cut_off_date_display = [];
    delivery_date = [];
    project_description = "";
    other_information = "";
    cutoff_date: Array<any>;
    showCutOffDatePicker = true;
    showDeliveryDatePicker = true;
    sep = false;
    sso = false;
    usIpr = false;

    users_data: any;
    patent_number_error = false;
    useful_information_error = false;
    technical_field_error = false;
    interim_date_error = false;
    delivery_date_error = false;
    claim_search_error = false;
    cutoff_date_error = false;
    prior_art_error = false;
    patent_engineer_error = false;
    technical_expert_error = false;
    project_description_error = false;
    other_information_error = false;
    project_type_error = false;
    errorMessage = "";
    currentMonth: any;

    assignees_for_legal_counsel_and_IPR;

    showInterimDatePicker = true;

    fullScreenLoader = false;

    clickType = '';

    closeResult: string;
    @ViewChild('content') content: ElementRef;

    projectType = "";
    fieldNames = {};

    public modalRef: NgbModalRef;
    // On error, Focus variables
    public technical_expert_focus = new EventEmitter<boolean>();
    public patent_engineer_focus = new EventEmitter<boolean>();
    public known_prior_art_focus = new EventEmitter<boolean>();
    public prior_art_cut_off_date_focus = new EventEmitter<boolean>();
    public claims_to_be_searched_focus = new EventEmitter<boolean>();
    public required_delivery_date_focus = new EventEmitter<boolean>();
    public technical_field_focus = new EventEmitter<boolean>();
    public project_description_focus = new EventEmitter<boolean>();
    public other_information_focus = new EventEmitter<boolean>();
    public useful_information_focus = new EventEmitter<boolean>();
    public patent_number_focus = new EventEmitter<boolean>();
    public interim_date_focus = new EventEmitter<boolean>();
    public project_type_focus = new EventEmitter<boolean>();

    @ViewChild('cutoff_date_view') cutoff_date_view: MultipleDatePickerComponent;

    static arrayFromJson(arrayJson) {
        const newArray = [];
        for (let i = 0; i < arrayJson.length; i++) {
            newArray[i] = arrayJson[i].value
        }
        return newArray;
    }

    static convertStringArrayToInt(stringArray) {
        const intArray = [];
        for (let i = 0; i < stringArray.length; i++) {
            intArray.push(+stringArray[i]);
        }
        return intArray;
    }

    private static getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public data_service: DataService,
        private projectManagementService: ProjectManagementService,
        private _location: Location,
        private translate: TranslateService,
        public front_end_service: FrontEndService,
        private stateService: StateService,
        private logService: LogService,
        private cdr: ChangeDetectorRef
    ) {
        this.currentMonth = moment().add(2, 'y');
    }

    checkSelection() {
        this.logService.printLog("cutoff_dates" + this.cutoff_date);
        this.prior_art_cut_off_date = [];
        this.prior_art_cut_off_date_display = [];
        for (let i = 0; i < this.cutoff_date.length; i++) {
            this.logService.printLog("Selected dates = " + this.cutoff_date[i]);
            // to send with 2017-09-01 format
            const selectedDate = this.data_service.getFormattedDate(this.cutoff_date[i]);
            this.prior_art_cut_off_date.push(selectedDate);
            // to display with 01-sep-2017 format
            const selectedDateToDisplay = this.data_service.getFormattedDate(this.cutoff_date[i]);
            this.prior_art_cut_off_date_display.push(selectedDateToDisplay);
        }
    }

    cutOffDateEdited() {
        this.cutoff_date = [];
        for (let i = 0; i < this.prior_art_cut_off_date_display.length; i++) {
            this.logService.printLog("Cut off date - " + this.cutoff_date[i]);
            this.cutoff_date.push(moment(moment(this.prior_art_cut_off_date_display[i]).format("YYYY-MM-DDT") + "00:00Z"));
        }

        this.checkSelection();
        setTimeout(() => {
            this.cutoff_date_view.generate();
        }, 200);
    }

    singleDateSelection(event, date) {
        // Empty function needed to enable day selection
    }

    checkSelectionDelivery() {
        if (this.delivery_date[0]) {
            this.required_delivery_date = moment(this.delivery_date[0]._d).format("MMM DD, YYYY");
        } else {
            this.required_delivery_date = "";
        }
    }

    checkSelectionInterim() {
        if (this.interim_date[0]) {
            this.interim_date_string = moment(this.interim_date[0]._d).format("MMM DD, YYYY");
        } else {
            this.interim_date_string = "";
        }
    }

    ngOnInit() {
        this.cutoff_date = [];
        this.fetchUsers();
    }

    setUser(userId) {
        this.fetchUsers(userId);
    }

    get_existing_users(users) {
        const obj1 = {};
        obj1['role'] = users['role'].toString();
        obj1['value'] = users['id'].toString();
        obj1['display'] = users.name + '(' + users.username + ')';
        return obj1;
    }

    fetchUsers(userid = null) {
        this.fullScreenLoader = true;
        this.user_management_service.userList((resp) => {
            this.users_data = resp.data;
            const inputTag = [];

            for (let i = 0; i < this.users_data.length; i++) {
                const obj = {};
                obj['role'] = this.users_data[i]['role'].toString();
                obj['value'] = this.users_data[i]['id'].toString();
                obj['display'] = this.users_data[i].name + '(' + this.users_data[i].username + ')';
                if (this.users_data[i]['is_active']) {
                    inputTag.push(obj);
                }

                // Condition for new user
                if(userid != null) {
                    if(this.users_data[i]['id'] === userid) {
                        const obj2 = {};
                        obj2['role'] = this.users_data[i]['role'].toString();
                        obj2['id'] = this.users_data[i]['id'].toString();
                        obj2['name'] = this.users_data[i].name;
                        obj2['username'] = this.users_data[i].username;

                        if(this.clickType === "patent_engineer" && obj2["role"] === "3") {
                            this.patent_engineer.push(this.get_existing_users(obj2));
                        }
                        if(this.clickType === "technical_expert" && obj2["role"] === "3") {
                            this.technical_expert.push(this.get_existing_users(obj2));
                        }
                        if(this.clickType === "legal_counsel" && obj2["role"] === "3") {
                            this.legal_counsel.push(this.get_existing_users(obj2));
                        }
                    }
                }
            }

            const assignees_for_patent_engineer_and_technicalExpert = this.data_service.filter_on_role_type(inputTag, '3')
            const filter_by_user_type_customerAdmin = this.data_service.filter_on_role_type(inputTag, '4');
            this.assignees_for_legal_counsel_and_IPR = assignees_for_patent_engineer_and_technicalExpert.concat(filter_by_user_type_customerAdmin);
            this.projectTypeChanged({ 'value': '0' });
            this.fullScreenLoader = false;
        });

    }

    onSubmit(projectDetails) {
        if (projectDetails.project_type.trim() === "" || projectDetails.project_type.trim() === 'null') {
            this.hideAllErrors();
            this.project_type_focus.emit(true);
            this.project_type_error = true;
            this.errorMessage = 'select_project_type';
        } else if (projectDetails.title.trim() === "" || projectDetails.title === undefined) {
            this.hideAllErrors();
            this.patent_number_focus.emit(true);
            this.patent_number_error = true;
            this.errorMessage = 'please_enter_a_patent_number';
        } else if (projectDetails.required_delivery_date === "") {
            this.hideAllErrors();
            this.required_delivery_date_focus.emit(true);
            this.delivery_date_error = true;
            this.errorMessage = 'please_select_a_delivery_date';
        } else if (projectDetails.claims_to_be_searched.trim() === "" || projectDetails.claims_to_be_searched === undefined) {
            this.hideAllErrors();
            this.claims_to_be_searched_focus.emit(true);
            this.claim_search_error = true;
            this.errorMessage = 'please_enter_claim_search';
        } else {
            this.hideAllErrors();
            if(this.interim_date_string !== "") {
                projectDetails['interim_date'] = moment(this.interim_date[0]._d).format("YYYY-MM-DDT") + "00:00Z";
            }
            projectDetails['patent_engineer'] = CreateProjectComponent.convertStringArrayToInt(CreateProjectComponent.arrayFromJson(this.patent_engineer));
            projectDetails['technical_expert'] = CreateProjectComponent.convertStringArrayToInt(CreateProjectComponent.arrayFromJson(this.technical_expert));
            projectDetails['legal_counsel'] = CreateProjectComponent.convertStringArrayToInt(CreateProjectComponent.arrayFromJson(this.legal_counsel));
            projectDetails['required_delivery_date'] = moment(this.delivery_date[0]._d).format("YYYY-MM-DDTHH:mm") + "Z";

            const cutOffDates = [];
            for (let i = 0; i < this.cutoff_date.length; i++) {
                this.logService.printLog("Cut off date - " + this.cutoff_date[i]);
                cutOffDates.push({
                    "this_date": moment(this.cutoff_date[i]._d).format("YYYY-MM-DDT") + "00:00Z"
                });
            }
            projectDetails['prior_art_cut_off_date'] = cutOffDates;
            projectDetails['subject_patent'] = projectDetails.useful_information;
            delete projectDetails.useful_information;
            delete projectDetails.multi_date;
            delete projectDetails.delivery_date_picker;

            if(!projectDetails['interim_date']) {
                delete projectDetails.interim_date;
            }
            this.logService.printLog("Create Project object - " + projectDetails);
            this.fullScreenLoader = true;
            this.projectManagementService.create_project(projectDetails, (resp) => {
                this.fullScreenLoader = false;
                if (resp.status === true) {
                    this.emptyForm();
                    this.front_end_service.addToast(
                        "Success",
                        "project_created_successfully",
                        "success"
                    );
                    this.stateService.go(
                        'project',
                        {
                            project_id: resp.data['fip_id']
                        }
                    );
                }
            });
        }
    }

    hideAllErrors() {
        this.technical_expert_error = false;
        this.patent_engineer_error = false;
        this.prior_art_error = false;
        this.cutoff_date_error = false;
        this.claim_search_error = false;
        this.delivery_date_error = false;
        this.technical_field_error = false;
        this.project_description_error = false;
        this.other_information_error = false;
        this.useful_information_error = false;
        this.patent_number_error = false;
        this.interim_date_error = false;
        this.project_type_error = false;
    }

    emptyForm() {
        this.title = "";
        this.useful_information = "";
        this.required_delivery_date = "";
        this.technical_field = "";
        this.claim_search = "";
        this.prior_art = "";
        this.project_status = "";
        this.empty_value = "";
        this.patent_engineer = [];
        this.technical_expert = [];
        this.prior_art_cut_off_date = [];
        this.prior_art_cut_off_date_display = [];
        this.project_description = "";
        this.other_information = "";
        this.cutoff_date = [];
        this.showCutOffDatePicker = true;
        this.showDeliveryDatePicker = true;
        this.projectType = "";
    }

    open(content, type) {
        this.clickType = type;
        this.modalRef = this.modalService.open(content, { size: 'lg' });
        this.modalRef.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${CreateProjectComponent.getDismissReason(reason)}`;
        });
    }

    closeModal() {
        this.modalRef.close();
        this.fetchUsers();
    }

    projectTypeChanged(event) {
        this.projectType = event.value;
        this.fieldNames = this.data_service.getFieldNamesBasedOnProjectType(this.projectType);
        this.cdr.detectChanges();
    }
}
